/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorCounselingReportDesiredTimeTypename =
  "PharmacyCounselorCounselingReportDesiredTime" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorCounselingReportDesiredTime
 */
export interface PharmacyCounselorCounselingReportDesiredTime {
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorCounselingReportDesiredTime
   */
  pickup?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorCounselingReportDesiredTime
   */
  readonly __typename?: string;
}

export function PharmacyCounselorCounselingReportDesiredTimeFromJSON(
  json: any
): PharmacyCounselorCounselingReportDesiredTime {
  return PharmacyCounselorCounselingReportDesiredTimeFromJSONTyped(json, false);
}

export function PharmacyCounselorCounselingReportDesiredTimeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorCounselingReportDesiredTime {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorCounselingReportDesiredTimeTypename,

    pickup: !exists(json, "pickup") ? undefined : json["pickup"],
  };
}

export function PharmacyCounselorCounselingReportDesiredTimeToJSON(
  object?: PharmacyCounselorCounselingReportDesiredTime | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    pickup: value.pickup,
  };
}
